import { render } from "./InputsContainer.vue?vue&type=template&id=f7b791b2"
import script from "./InputsContainer.vue?vue&type=script&lang=js"
export * from "./InputsContainer.vue?vue&type=script&lang=js"

import exportComponent from "/builds/Xpansiv/evo/DataPipeline/DataPipeline.Evolve.Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__